module.exports = __webpack_public_path__ + "static/img/low-profile-single-pedestal-with-wood-frame.3afa4cb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/pedestals/low-profile-single-pedestal-with-wood-frame.jpg
// module id = 716
// module chunks = 0